import { useEffect, useState } from 'react';
import { fetchAdsHealth } from '../api';
import type { AdsHealth } from '../types';

const POLL_INTERVAL_MS = 5000;

/**
 * Hook for the ads service's `/health` endpoint.
 *
 * Mirrors `useInteriorHealth` / `useVideoHealth` so `AppShell` can
 * normalise all four sub-app health responses into the same
 * `SystemStatusCounts` envelope regardless of which mini-app is
 * currently active.
 */
export function useAdsHealth() {
  const [health, setHealth] = useState<AdsHealth | null>(null);
  const [beLive, setBeLive] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const tick = async () => {
      try {
        const data = await fetchAdsHealth();
        if (cancelled) return;
        setHealth(data);
        setBeLive(true);
      } catch {
        if (cancelled) return;
        setBeLive(false);
      }
    };
    tick();
    const id = window.setInterval(tick, POLL_INTERVAL_MS);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, []);

  return { health, beLive };
}
